<ion-header>
  <top-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></top-nav-component>
</ion-header>

<ion-content>
  <page-loader-comp *ngIf="!longLoading && !initPageDone"></page-loader-comp>

  <bloc-header-comp
    [compOptions]="{
      'title': blocHeaderTitle,
      'mobile': false,
      'loading': !initPageDone
    }"
  >
  </bloc-header-comp>

  <!-- SHIMMER -->
  <div *ngIf="longLoading && !initPageDone">
    <div class="wpe-90 border-radius-6 padding-6 margin-v-6 shimmer"></div>
  </div>

  <div *ngIf="initPageDone" class="ion-content-container">
    Template Page
  </div>
</ion-content>

<ion-footer>
  <footer-nav-component [compOptions]="{'page': pageTitle, 'active': activeLink}"></footer-nav-component>
</ion-footer>
